// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"444":"17f9b06c","522":"18f6d44f","880":"1cd920d2"}[chunkId] + ".css";
};